import React, { type ReactElement } from 'react';
import { styled } from '@compiled/react';
import EmptyState from '@atlaskit/empty-state';
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles
import { gridSize } from '@atlassian/jira-common-styles/src';

type Props = {
	isLoading: boolean;
	imageUrl: string;
	header: string;
	description: string;
	primaryAction: ReactElement | undefined;
	secondaryAction: ReactElement | undefined;
	tertiaryAction: ReactElement | undefined;
};

export default function MessageCallToAction(props: Props) {
	return (
		<Root>
			<EmptyState maxImageWidth={width} maxImageHeight={height} {...props} />
		</Root>
	);
}

MessageCallToAction.defaultProps = {
	isLoading: false,
	primaryAction: undefined,
	secondaryAction: undefined,
	tertiaryAction: undefined,
};

export const height = gridSize * 20.5;
export const width = gridSize * 48;

// eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Root = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'> div': {
		/* Override AK's silly set width. */
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		maxWidth: `${gridSize * 58}px`,
		width: 'auto',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	img: {
		/* Force height of empty state image to prevent text jumping around */
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		minHeight: `${height}px`,
	},
});
